import React from "react";
import { Table } from "react-bootstrap";

import "../components/css/LatestTrans.css";

const MachinePerTable = ({ machineRanking, isLoading }) => {
    const formatValue = (val) => val ? parseFloat(val).toFixed(2) : "N/A";
    const dualPaymentItem = machineRanking.find(item =>
        item.paymentTypes?.includes("iPay88") && item.paymentTypes?.includes("mro")
    );
    const fallbackPaymentItem = machineRanking.find(item =>
        item.paymentTypes || item.Mode
    );
    const currentPaymentType = dualPaymentItem?.paymentTypes ||
        fallbackPaymentItem?.paymentTypes ||
        fallbackPaymentItem?.Mode ||
        "";
    const salesLabel = currentPaymentType.includes(", ")
        ? "Amount"
        : currentPaymentType.includes("commercial")
        ? "Sales"
        : currentPaymentType.includes("mro")
        ? "Credit"
        : "Amount";

    const getSalesOrCredits = (item) => {
        const mode = item.Mode;
        const paymentTypes = item.paymentTypes;

        if ((!paymentTypes || paymentTypes.trim() === "") && mode === "commercial") {
            return `Sales: ${formatValue(item.totalSales)}`;
        }

        if (mode === "mro") {
            if (paymentTypes?.includes("mro") && paymentTypes?.includes("iPay88")) {
                return `Sales: ${formatValue(item.sales)} | Credits: ${formatValue(item.credits)}`;
            } else if (paymentTypes?.includes("mro") || paymentTypes === null) {
                return `Credits: ${formatValue(item.totalSales)}`;
            } else {
                return `Sales: ${formatValue(item.totalSales)}`;
            }
        } else if (mode === "commercial") {
            return `Sales: ${formatValue(item.totalSales)}`;
        }
    };

    return(
        <>
            <div className="macTabDiv">
                <h6 className="lblMachineTable">Machine Ranking</h6>

                <Table striped bordered hover responsive size="sm">
                    <thead>
                        <tr>
                            <th>Machine</th>
                            <th>Frequency</th>
                            <th>{salesLabel}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="4" style={{ textAlign: "center", padding: "10px", fontStyle: "italic", fontWeight: "bold" }}>
                                    Loading...
                                </td>
                            </tr>
                        ) : machineRanking?.length > 0 ? (
                            machineRanking.map((items) => {
                                return (
                                    <tr key={items.machineId}>
                                        <td className="fontHandle">{items.machineUUID}</td>
                                        <td className="fontHandle">{items.frequency}</td>
                                        <td className="fontHandle">
                                            {getSalesOrCredits(items)}
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="4" style={{ textAlign: "center", padding: "10px", fontStyle: "italic" }}>
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </>
    );
};

export default MachinePerTable;